// extracted by mini-css-extract-plugin
export default {"navigationButton":"CaN1No9YR93zjRKrEcD6","navigationButtonFullPage":"_5g3ANHyXKd70_qppl4N"};